// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__gr2PG","boxTitle":"Qualiphy_boxTitle__2P0gd","box":"Qualiphy_box__1g10S","toggleWrap":"Qualiphy_toggleWrap__RNfhS"};